<div class="tooltip-container" [ngClass]="{'show-tooltip': isVisible}">
  <div
    [ngClass]="{'tooltip-content': true, 'tooltip-top': position === 'top', 'tooltip-bottom': position === 'bottom', 'change-position': positionChange }">
    <div class="custom_iconTooltip" ></div>
    <span class="tooltip-text" [innerHTML]="text"></span>
  </div>
</div>